type Slug =
  | 'home'
  | 'projects'
  | 'blog'
  | 'research'
    | 'v1';

export type Route = {
  path: string,
  name: string,
};

type Routes = Record<Slug, Route>;

export const routes: Routes = {
  home: {
    path: '/',
    name: 'About',
  },
  projects: {
    path: '/projects',
    name: 'Projects',
  },
  research: {
    path: '/research',
    name: 'Research',
  },
  blog: {
    path: '/blog',
    name: 'Blog',
  },
  v1: {
    path: 'https://v1.yuyangwang.org',
    name: 'v1',
  },
};
